import React, { useMemo, useState } from 'react';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import { Search, Wrench } from 'lucide-react';
import ToolAccessBadge from './ToolAccessBadge';
import { PLATFORM_MCP_COPY } from '../../constants/platformMcpCopy';
import pageStyles from '../MyLLMKeys/MyLLMKeys.module.scss';
import styles from './PlatformMcp.module.scss';

/** "What it can do": the tools an AI app can call in Quadroid. */
const ToolsTab = ({ tools }) => {
  const [query, setQuery] = useState('');

  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return tools;
    return tools.filter(
      (t) => (t.title || '').toLowerCase().includes(q) || (t.description || '').toLowerCase().includes(q)
    );
  }, [tools, query]);

  if (!tools.length) {
    return (
      <Box className={pageStyles.emptyState}>
        <Wrench className={pageStyles.emptyIcon} size={44} />
        <Typography variant="body2">{PLATFORM_MCP_COPY.noTools}</Typography>
      </Box>
    );
  }

  return (
    <Box className={styles.tabBody}>
      <TextField
        size="small"
        placeholder="Search tools"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        sx={{ maxWidth: 360 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search size={16} />
            </InputAdornment>
          ),
        }}
      />
      <Box className={styles.toolGrid}>
        {visible.map((t) => (
          <Box key={t.name} className={styles.toolCard}>
            <Box className={styles.toolHead}>
              <Typography className={styles.toolTitle}>{t.title || t.name}</Typography>
              <ToolAccessBadge readOnly={!!t.read_only} />
            </Box>
            {t.description && (
              <Typography variant="body2" className={styles.muted}>
                {t.description}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
      {visible.length === 0 && (
        <Typography variant="body2" className={styles.muted}>
          No tools match “{query}”.
        </Typography>
      )}
    </Box>
  );
};

export default ToolsTab;
